// Normalizes a possibly-undefined/null value into an array, returning [] for non-array input.
export const toArray = <T>(
  arrayCandidate: Array<T> | undefined | null,
): Array<T> => (Array.isArray(arrayCandidate) ? arrayCandidate : []);
